import Odlazak from "../odlazak/Odlazak"
import Dolazak from "../dolazak/Dolazak"
import { Button, Tabs, TabList, Tab, TabPanels,TabPanel, Box } from "@chakra-ui/react"
import { MdCancel } from "react-icons/md"
import GovedoView from "../govedo/GovedoView"

export default function MigracijaCard({govedoid,dolmigrid,dolmigsif,odlmigrid,odlmigsif,onClose}) {
  return (
    <Box h={'80vh'}>
      <Tabs variant='enclosed' overflow={'auto'} size={'sm'} h={'100%'} colorScheme="grunt2">
        <TabList>
          <Tab _focus={{fontWeight:'bold'}}>Govedo</Tab>
          <Tab _focus={{fontWeight:'bold'}}>Dolazak</Tab>
          {odlmigrid!==0?<Tab _focus={{fontWeight:'bold'}}>Odlazak</Tab>:<></>}
        </TabList>
        <TabPanels>
          <TabPanel>
              <GovedoView _idgoveda={govedoid}/>
          </TabPanel>
          <TabPanel><Dolazak readonly={true} newDolazak={false} dolazakMigracijaId={dolmigrid} dolazak_tip_sifra={dolmigsif} isMigracijaView={true}/></TabPanel>
          {odlmigrid!==0?<TabPanel><Odlazak readonly={true} newOdlazak={false} odlazakMigracijaId={odlmigrid} odlazak_tip_sifra={odlmigsif} isMigracijaView={true}/></TabPanel>:<></>}
        </TabPanels>
      </Tabs>
      <Button mt={'2rem'} colorScheme={'grunt2'} rightIcon={<MdCancel/>} variant={'outline'} size={'xs'} onClick={onClose} >Odustani</Button>
    </Box>
  )
}
